import styled from "styled-components";
import { TextRegular } from "../../styles/GlobalStyledComponents";

export const TextRegularEllipsis = styled(TextRegular)`
  white-space: nowrap;
  width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ShippingOptions = styled.div`
  margin: 20px 0;
`;

export const ShippingButton = styled.div`
  border: 1px solid #878786;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 6px;
  opacity: 1;
  height: 70px;
  cursor: pointer;
  margin-bottom: 1rem;
  display: flex;

  &:hover {
    background: #e3e1e1 0% 0% no-repeat padding-box;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ButtonCheckbox = styled.input`
  margin: 0 25px;
  width: 1em;
  height: 1em;
  background-color: white;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid rgba(0, 0, 0, 0.25);
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  &:checked {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23FF3333'/%3e%3c/svg%3e");
    border-color: rgb(135, 135, 134);
  }
`;

export const ButtonText = styled.div`
  display: flex;
  width: 85%;
  flex-direction: column;
  justify-content: center;
`;

export const OperationSentImage = styled.img`
  width: 100%;
  height: 100%;
`;
